(() => {
var $46728f2f60155741$export$3be962be852346df = /** @class */ function() {
    function MerCalculator() {
        this.TRANSLATIONS_EN = {
            Method: "Method",
            "Age and Activity": "Age and Activity",
            Weight: "Weight",
            Age: "Age",
            "<8 weeks": "<8 weeks",
            "8-52 weeks": "8-52 weeks",
            "1-2 years": "1-2 years",
            "3-7 years": "3-7 years",
            ">7 years (senior)": ">7 years (senior)",
            "Expected Mature Weight": "Expected Mature Weight",
            Activity: "Activity",
            "Number of Kittens": "Number of Kittens",
            "Recommended calories": "Recommended calories",
            "Low Activity": "Low Activity (<1 hour/day)",
            "Moderate Activity (low impact)": "Moderate Activity (1-3 hour/day, low impact)",
            "Moderate Activity(high impact)": "Moderate Activity(1-3 hour/day, high impact)",
            "High activity (working dogs)": "High activity (3-6 hours/day working dogs)",
            "High activity under extreme conditions": "High activity under extreme conditions"
        };
    }
    /**
     * Calculates the daily maintenance energy requirements (MER) for a dog based on age, covering newborn puppies to adult dogs.
     * @param {number} weight - The weight of the dog in kilograms.
     * @param {number} ageInMonths - The age of the dog in months.
     * @param {number} expectedMatureWeight - The expected mature weight of the dog in kilograms (required for puppies between 8 weeks and 1 year).
     * @returns {number} - The daily MER of the dog in kcal.
     */ MerCalculator.prototype.calculateDogEnergyByAge = function(weight, ageInMonths, expectedMatureWeight) {
        if (expectedMatureWeight === void 0) expectedMatureWeight = 0;
        var energyRequirement = 0;
        var weightFactor = Math.pow(weight, 0.75); // Common factor in all calculations
        // For newborn puppies (< 8 weeks)
        if (ageInMonths < 2) energyRequirement = weight * 25000 / 100; // Convert weight to grams and calculate
        else if (ageInMonths >= 2 && ageInMonths < 12) {
            var ratio = weight / expectedMatureWeight;
            energyRequirement = (254.1 - 135.0 * ratio) * weightFactor;
        } else {
            var ageInYears = ageInMonths / 12;
            if (ageInYears >= 1 && ageInYears <= 2) energyRequirement = weightFactor * 130;
            else if (ageInYears > 2 && ageInYears <= 7) energyRequirement = weightFactor * 110;
            else if (ageInYears > 7) energyRequirement = weightFactor * 95;
        }
        return energyRequirement;
    };
    /**
     * Calculates the daily energy requirements (DER) for an adult dog based on activity level
     * @param {number} weight - The weight of the dog in kilograms
     * @param {string} activityLevel - The activity level of the dog (low, moderateLow, moderateHigh, high, extreme)
     * @returns {number} - The daily DER of the dog in kcal
     */ MerCalculator.prototype.calculateDogEnergyByActivity = function(weight, activityLevel) {
        var energyRequirement = 0;
        var weightFactor = Math.pow(weight, 0.75); // Common factor in all calculations
        switch(activityLevel){
            case "low":
                energyRequirement = weightFactor * 95;
                break;
            case "moderateLow":
                energyRequirement = weightFactor * 110;
                break;
            case "moderateHigh":
                energyRequirement = weightFactor * 125;
                break;
            case "high":
                energyRequirement = weightFactor * 150; // Assuming average for high activity
                break;
            case "extreme":
                energyRequirement = weightFactor * 1050; // Assuming average for extreme conditions
                break;
            default:
                break;
        }
        return energyRequirement;
    };
    /**
     * Creates and displays a form for calculating the daily energy requirements of a dog.
     * The form allows the user to input the dog's weight, age, activity level, and any peculiarities (e.g., neutered, gestating, lactating).
     * Based on the input values, the function calculates and displays the recommended daily energy requirements for the dog.
     *
     * @param {HTMLElement} element - The HTML element where the form will be displayed.
     * @param {Object} translations - (Optional) An object containing translated text for form labels and messages.
     *                                If not provided, English translations will be used.
     * @param {string|undefined}    - The HTML to display at the footer of the form, default to creditation link
     * @returns {Object} - An object containing references to the form elements for further manipulation, such as retrieving user inputs or updating the displayed recommendations.
     */ MerCalculator.prototype.createDogEnergyForm = function(element, translations, footerHtml) {
        var _this = this;
        if (translations === void 0) translations = undefined;
        if (footerHtml === void 0) footerHtml = 'Dog MER Calculator by <a href="https://voerkeur.nl/software/dog-mer-calculator/en/" target="_blank" class="dog-mer-credits">Voerkeur.nl</a>';
        if (translations === undefined) translations = this.TRANSLATIONS_EN;
        var weightDefault = 15;
        var methodOptions = [
            {
                value: "age",
                label: translations["Age"]
            },
            {
                value: "activity",
                label: translations["Activity"]
            },
            {
                value: "combined",
                label: translations["Age and Activity"],
                default: true
            }
        ];
        var ageOptions = [
            {
                value: "1",
                label: translations["<8 weeks"]
            },
            {
                value: "3",
                label: translations["8-52 weeks"]
            },
            {
                value: "16",
                label: translations["1-2 years"]
            },
            {
                value: "50",
                label: translations["3-7 years"],
                default: true
            },
            {
                value: "100",
                label: translations[">7 years (senior)"]
            }
        ];
        var activityOptions = [
            {
                value: "low",
                label: translations["Low Activity"]
            },
            {
                value: "moderateLow",
                label: translations["Moderate Activity (low impact)"],
                default: true
            },
            {
                value: "moderateHigh",
                label: translations["Moderate Activity(high impact)"]
            },
            {
                value: "high",
                label: translations["High activity (working dogs)"]
            },
            {
                value: "extreme",
                label: translations["High activity under extreme conditions"]
            }
        ];
        var updateVisbility = function() {
            var age = parseFloat(ageSelect.value);
            expectedMatureWeightDiv.hidden = !(age > 2 && age < 12);
            activityDiv.hidden = age < 12 || methodSelect.value == "age";
            ageDiv.hidden = methodSelect.value == "activity";
        };
        // Function to calculate and update the recommended calories
        var updateRecommendedCalories = function() {
            var weight = parseFloat(weightInput.value);
            var ageInMonths = ageSelect.value ? parseFloat(ageSelect.value) : 0;
            var activity = activitySelect.value;
            var expectedMatureWeight = expectedMatureWeightInput.value ? parseFloat(expectedMatureWeightInput.value) : 0;
            recommendedCaloriesSpan.textContent = "?";
            if (methodSelect.value == "age") {
                var recommendedCalories = _this.calculateDogEnergyByAge(weight, ageInMonths, expectedMatureWeight);
                recommendedCaloriesSpan.textContent = recommendedCalories.toFixed(0);
            } else if (methodSelect.value == "activity") {
                var recommendedCalories = _this.calculateDogEnergyByActivity(weight, activity);
                recommendedCaloriesSpan.textContent = recommendedCalories.toFixed(0);
            } else if (methodSelect.value == "combined") {
                var ageCalories = _this.calculateDogEnergyByAge(weight, ageInMonths, expectedMatureWeight);
                var activityCalories = _this.calculateDogEnergyByActivity(weight, activity);
                var recommendedCalories = (ageCalories + activityCalories + activityCalories) / 3;
                recommendedCaloriesSpan.textContent = recommendedCalories.toFixed(0);
            }
        };
        var methodDiv = document.createElement("div");
        var methodLabel = document.createElement("label");
        methodLabel.textContent = translations["Method"] + ": ";
        var methodSelect = document.createElement("select");
        methodOptions.forEach(function(option) {
            var methodOption = document.createElement("option");
            methodOption.value = option.value;
            methodOption.textContent = option.label;
            if (option.default) methodOption.selected = true;
            methodSelect.appendChild(methodOption);
        });
        methodSelect.addEventListener("change", updateRecommendedCalories);
        methodSelect.addEventListener("change", updateVisbility);
        methodDiv.appendChild(methodLabel);
        methodDiv.appendChild(methodSelect);
        element.appendChild(methodDiv);
        // Create the weight input field
        var weightDiv = document.createElement("div");
        var weightLabel = document.createElement("label");
        weightLabel.textContent = translations["Weight"] + ": ";
        var weightInput = document.createElement("input");
        weightInput.type = "number";
        weightInput.value = weightDefault + "";
        weightInput.min = "0";
        weightInput.addEventListener("input", updateRecommendedCalories);
        weightDiv.appendChild(weightLabel);
        weightDiv.appendChild(weightInput);
        element.appendChild(weightDiv);
        // Create the age select field
        var ageDiv = document.createElement("div");
        var ageLabel = document.createElement("label");
        ageLabel.textContent = translations["Age"] + ": ";
        var ageSelect = document.createElement("select");
        ageOptions.forEach(function(option) {
            var ageOption = document.createElement("option");
            ageOption.value = option.value;
            ageOption.textContent = option.label;
            if (option.default) ageOption.selected = true;
            ageSelect.appendChild(ageOption);
        });
        ageSelect.addEventListener("change", updateRecommendedCalories);
        ageSelect.addEventListener("change", updateVisbility);
        ageDiv.appendChild(ageLabel);
        ageDiv.appendChild(ageSelect);
        element.appendChild(ageDiv);
        var expectedMatureWeightDiv = document.createElement("div");
        var expectedMatureWeightLabel = document.createElement("label");
        expectedMatureWeightLabel.textContent = translations["Expected Mature Weight"] + ": ";
        var expectedMatureWeightInput = document.createElement("input");
        expectedMatureWeightInput.type = "number";
        expectedMatureWeightInput.value = weightDefault + "";
        expectedMatureWeightInput.min = "0";
        expectedMatureWeightInput.addEventListener("input", updateRecommendedCalories);
        expectedMatureWeightDiv.appendChild(expectedMatureWeightLabel);
        expectedMatureWeightDiv.appendChild(expectedMatureWeightInput);
        expectedMatureWeightDiv.hidden = true;
        element.appendChild(expectedMatureWeightDiv);
        // Create the activity select field
        var activityDiv = document.createElement("div");
        var activityLabel = document.createElement("label");
        activityLabel.textContent = translations["Activity"] + ": ";
        var activitySelect = document.createElement("select");
        activityOptions.forEach(function(option) {
            var activityOption = document.createElement("option");
            activityOption.value = option.value;
            activityOption.textContent = option.label;
            if (option.default) activityOption.selected = true;
            activitySelect.appendChild(activityOption);
        });
        activitySelect.addEventListener("change", updateRecommendedCalories);
        activityDiv.appendChild(activityLabel);
        activityDiv.appendChild(activitySelect);
        activityDiv.appendChild(activitySelect);
        element.appendChild(activityDiv);
        // Create the recommended calories display
        var recommendedCaloriesDiv = document.createElement("div");
        var recommendedCaloriesText = document.createElement("span");
        recommendedCaloriesText.textContent = translations["Recommended calories"] + ": ";
        var recommendedCaloriesSpan = document.createElement("span");
        recommendedCaloriesDiv.appendChild(recommendedCaloriesText);
        recommendedCaloriesDiv.appendChild(recommendedCaloriesSpan);
        recommendedCaloriesDiv.append(" Kcal");
        element.appendChild(recommendedCaloriesDiv);
        if (footerHtml) {
            var footerHtmlDiv = document.createElement("div");
            footerHtmlDiv.innerHTML = footerHtml;
            element.appendChild(footerHtmlDiv);
        }
        // Initialize the recommended calories
        methodSelect.dispatchEvent(new Event("change"));
        updateRecommendedCalories();
        return {
            method: methodSelect,
            expectedMatureWeight: expectedMatureWeightInput,
            weight: weightInput,
            age: ageSelect,
            activity: activitySelect,
            recommendedCalories: recommendedCaloriesSpan
        };
    };
    return MerCalculator;
}();




// Calculator library
const $6f842f77604a5ed5$var$calculator = new (0, $46728f2f60155741$export$3be962be852346df)();
// Initialization
document.addEventListener("DOMContentLoaded", ()=>{
    // Calorie calculator forms
    document.querySelectorAll(".calories_calculator").forEach((mainElement)=>{
        const out = $6f842f77604a5ed5$var$calculator.createDogEnergyForm(mainElement, translations, "");
        out.weight.step = "0.1";
        // resetting and storing values
        const loadFromStorage = ()=>{
            const data = window.localStorage.getItem("calories_data_new");
            if (data != null) {
                const stored = JSON.parse(data);
                out.method.value = stored.method ?? out.method.value;
                out.expectedMatureWeight.value = stored.expectedMatureWeight ?? out.expectedMatureWeight.value;
                out.weight.value = stored.weight ?? out.weight.value;
                out.age.value = stored.age ?? out.age.value;
                out.activity.value = stored.activity ?? out.activity.value;
            }
        };
        const resetLink = document.createElement("a");
        resetLink.textContent = translations["Reset"] || "Reset";
        resetLink.href = "#";
        resetLink.addEventListener("click", (ev)=>{
            window.localStorage.removeItem("calories_data_new");
            loadFromStorage();
            ev.preventDefault();
        });
        mainElement.appendChild(resetLink);
        mainElement.append("\r\n");
        const saveLink = document.createElement("a");
        saveLink.textContent = translations["Save"] || "Save";
        saveLink.href = "#";
        saveLink.addEventListener("click", (ev)=>{
            window.localStorage.setItem("calories_data_new", JSON.stringify({
                method: out.method.value,
                expectedMatureWeight: out.expectedMatureWeight.value,
                weight: out.weight.value,
                age: out.age.value,
                activity: out.activity.value
            }));
            // @ts-ignore
            ev.target.blur();
            ev.preventDefault();
        });
        mainElement.appendChild(saveLink);
        mainElement.querySelectorAll(".calories_close").forEach((el)=>el.addEventListener("click", (ev)=>{
                // @ts-ignore
                ev.target.blur();
                ev.preventDefault();
            }));
        // Observing changes and applying them to entire page
        function updateGlobals() {
            document.querySelectorAll(".global_calories_recommend").forEach((el)=>el.innerHTML = out.recommendedCalories.innerText + " Kcal");
            document.querySelectorAll(".calories_food_amount").forEach((el)=>el.innerHTML = "" + Math.round(parseInt(out.recommendedCalories.innerText) * 100 / parseInt(el.dataset.cal)));
            document.querySelectorAll(".calories_price_day").forEach((el)=>{
                console.log(el);
                const price = parseFloat(el.dataset.priceKg) // price in euro per kg
                ;
                const amount = parseInt(out.recommendedCalories.innerText) * 100 / parseInt(el.dataset.cal) // amount in grams
                ;
                el.innerHTML = Intl.NumberFormat(translations["locale"] ?? "en-GB", {
                    style: "currency",
                    currency: "EUR"
                }).format(price * amount / 1000);
            });
        }
        const changeObserver = new MutationObserver(updateGlobals);
        changeObserver.observe(out.recommendedCalories, {
            characterData: true,
            subtree: true,
            childList: true
        });
        document.querySelectorAll(".calories_food_amount").forEach((el)=>changeObserver.observe(el, {
                attributes: true
            }));
        // initial load
        loadFromStorage();
        updateGlobals();
    });
    // find food calorie forms and make them change calories_food_amount when changed
    document.querySelectorAll("#caloriesper100g").forEach((caloriesInput)=>{
        caloriesInput.addEventListener("change", (input)=>{
            // @ts-ignore
            document.querySelectorAll(".calories_food_amount").forEach((el)=>el.dataset.cal = input.target.value);
        });
        caloriesInput.dispatchEvent(new Event("change"));
    });
});

})();
//# sourceMappingURL=dog-mer-calculator.js.map
